/** Per-user; bump suffix (v1 → v2) to re-show a future announcement. */
export const FAMILY_RENAME_CALLOUT_STORAGE_PREFIX = 'wetree-family-rename-callout-v1-dismissed';
